import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTUREGOVERNMENTS,
    RETRIEVE_ARCHITECTUREGOVERNMENTS,
    RETRIEVESINGLE_ARCHITECTUREGOVERNMENTS,
    UPDATE_ARCHITECTUREGOVERNMENTS,
    DELETE_ARCHITECTUREGOVERNMENTS,
} from "./type";
import ARCGovernment from "../service/arcGovernment";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCGovernment.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCGovernment.create(data);
        dispatch({
            type: CREATE_ARCHITECTUREGOVERNMENTS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCGovernment.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTUREGOVERNMENTS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCGovernment.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTUREGOVERNMENTS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCGovernment.update(data);
        dispatch({
            type: UPDATE_ARCHITECTUREGOVERNMENTS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCGovernment.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTUREGOVERNMENTS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCGovernment.trash(data);
        dispatch({
            type: DELETE_ARCHITECTUREGOVERNMENTS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};